import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AcademicYearService } from '../../../../../core/services/academic-year.service';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { IgxStepperModule, IStepChangingEventArgs } from 'igniteui-angular';
import { IgxStepper } from 'igniteui-angular/lib/stepper/stepper.common';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-academic-year-closure',
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        LoadingComponent,
        HeaderComponent,
        SampleSearchPipe,
        NgSelectModule,
        IgxStepperModule,
        NgxPaginationModule,
    ],
    templateUrl: './academic-year-closure.component.html',
    styleUrls: ['./academic-year-closure.component.css']
})
export class AcademicYearClosureComponent implements OnInit{
  ayId:any
  data:any
  @ViewChild("reqTop") reqTop!: ElementRef<HTMLElement>;
  @ViewChild('stepper')stepper!:IgxStepper
  @ViewChild('fileInp')fileInp!:ElementRef
  loading1=false
  loading2=false
  loading3=false
  loading4=false
  loading5=false
  loading6=false
  loading7=false
  loading8=false


  constructor(
    private ayService:AcademicYearService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
      private router:Router,
      private route:ActivatedRoute,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }

     
  ngOnInit(): void {
    this.ayId=this.route.snapshot.paramMap.get('id')
    if(this.ayId) this.get()

  }



  get(){
    this.ayService.get(this.ayId).subscribe((res:any)=>{
      this.data=res.data
        this.toastrService.success(res.message)
    },
    (err:any)=>{
        AppSweetAlert.simpleAlert("error","Configuration interface",err.error.message)
    })
   }

   reload(){
    if (!this.data.primaire1_migrated ||
      !this.data.primaire2_migrated ||
      !this.data.primaire3_migrated ||
      !this.data.college_migrated ||
      !this.data.lycee_migrated ||
      !this.data.professor_migrated ||
      !this.data.program_migrated ||
      !this.data.is_closed 
     ) {
      if(!this.data.primaire1_migrated)this.loading1=true
      if(!this.data.primaire2_migrated)this.loading2=true
      if(!this.data.primaire3_migrated)this.loading3=true
      if(!this.data.college_migrated)this.loading4=true
      if(!this.data.lycee_migrated)this.loading5=true
      if(!this.data.professor_migrated)this.loading6=true
      if(!this.data.program_migrated)this.loading7=true
      if(!this.data.is_closed)this.loading8=true
      this.store()
    }
   }

   store(){
    this.loading1=true
    this.ayService.closure(this.ayId).subscribe((res:any)=>{
      this.data=res.data
      this.resetLoader()
      this.toastrService.success(res.message)
      this.reload()
    },
    (err:any)=>{
      this.resetLoader()

        AppSweetAlert.simpleAlert("error","Configuration interface",err.error.message)
    })
   }

   resetLoader(){
    this.loading1=false
      this.loading2=false
      this.loading3=false
      this.loading4=false
      this.loading5=false
      this.loading6=false
      this.loading7=false
      this.loading8=false
   }


   prev(){
    this.stepper.prev()
  }
  next(){
    this.stepper.next()
  }

  public handleActiveStepChanging(event: IStepChangingEventArgs) {
    if (event.newIndex >  event.oldIndex) {

    switch (event.oldIndex) {

      case 0:
         // this.verifyStepper1(event)
        break;
  
    
      default:
        break;
    }
  }
   }
}
